<template>
    <div class="relative overflow-hidden w-full px-8 py-10 md:py-16 lg:py-24 xl:py-20 xl:px-0">
        <div class="container flex flex-col items-center justify-between h-full max-w-6xl mx-auto">
            <h2 class=" text-base font-medium tracking-tight text-orange-500 uppercase">Pets Await You!</h2>
            <h3
                class="max-w-2xl px-5 mt-2 text-3xl font-black leading-tight text-center text-gray-900 sm:mt-0 sm:px-0 sm:text-6xl">
                Meet our little bundles of joy</h3>
            <div
                class="flex flex-col w-full mt-3 text-center lg:flex-row lg:justify-center lg:flex-wrap sm:mt-10 lg:mt-20">
                <HomeProductCard v-for="x in PuppyDetails.slice(0, 3)" :key="x.id" :title="x.name" :breed="x.breed"
                    :img-url="x.src" />
            </div>
        </div>
    </div>
</template>

<script>
// import ProductCard from './cards/ProductCard.vue'
import HomeProductCard from './cards/HomeProductCard.vue'
import PuppyData from '@/assets/json/PuppyData.json'

export default {
    name: 'PuppyList',
    components: {
        // ProductCard,
        HomeProductCard
    },
    props: {},
    data() {
        return {
            PuppyDetails: PuppyData
        };
    }
};
</script>

<style scoped></style>
